import { MixpanelEvent, type BlotterGroupingDefinition, type Position } from '@talos/kyoko';
import type { ExtraPositionColumns } from '../types';

export type PredictionsGroupings = 'Underlying' | 'Market Account';
type GroupablePositionColumns = keyof Position | ExtraPositionColumns;

const PREDICTION_HIERARCHY_COLUMNS: GroupablePositionColumns[] = [
  'predictionCategory',
  'predictionSeries',
  'predictionEvent',
];

export const POSITIONS_PREDICTIONS_GROUPINGS: BlotterGroupingDefinition<
  PredictionsGroupings,
  GroupablePositionColumns
>[] = [
  {
    key: 'Underlying',
    label: 'By Underlying',
    mobileLabel: 'Underlying',
    rowGroupColumns: PREDICTION_HIERARCHY_COLUMNS,
    mixpanelEvent: MixpanelEvent.GroupAssets,
    buttonDataTestId: 'by-underlying-button',
  },
  {
    key: 'Market Account',
    label: 'By Market Account',
    mobileLabel: 'Market Acct',
    rowGroupColumns: ['MarketAccount', ...PREDICTION_HIERARCHY_COLUMNS],
    mixpanelEvent: MixpanelEvent.GroupAccounts,
    buttonDataTestId: 'by-market-account-button',
  },
];
